import { Routes, UNSAFE_RouteContext as RouteContext } from 'react-router';
import React, { useContext, useMemo } from 'react';

/* From https://github.com/remix-run/react-router/issues/8035#issuecomment-997737565,
  component necessary at the time of writing to reset the path of nested Routes. */
function ResetNestedRoutes(props) {
  const ctx = useContext(RouteContext);

  const value = useMemo(
    () => ({
      ...ctx,
      matches: []
    }),
    [ctx]
  );

  return (
    <RouteContext.Provider value={value}>
      <Routes {...props} key={props.keyForNestedRoutes} />
    </RouteContext.Provider>
  );
}

export default ResetNestedRoutes;
